<template>
    <div class="about-page">
        <div class="container">
            <!-- Hero Section -->
            <div class="hero-section">
                <div class="title-decoration">
                    <img class="decoration-icon"
                        src="https://static.weryai.com/growth/image/f64c34b9d90c706c21afb145dc0f101d.webp" alt="装饰图标"
                        width="60" height="60" loading="eager" aria-hidden="true" />
                    <h1 class="main-title">{{ t('aboutUs.pageTitle') }}</h1>
                    <img class="decoration-icon"
                        src="https://static.weryai.com/growth/image/f64c34b9d90c706c21afb145dc0f101d.webp" alt="装饰图标"
                        width="60" height="60" loading="eager" aria-hidden="true" />
                </div>
                <h2 class="subtitle">{{ t('aboutUs.subtitle') }}</h2>
                <p class="description">
                    {{ t('aboutUs.description') }}
                </p>
            </div>

            <!-- Platform Section -->
            <div class="platform-section">
                <h3 class="section-title">{{ t('aboutUs.platformTitle') }}</h3>
                <p class="section-description">
                    {{ t('aboutUs.platformDescription') }}
                </p>
            </div>

            <!-- Why Choose Section -->
            <div class="why-choose-section">
                <h3 class="section-title">{{ t('aboutUs.whyChooseTitle') }}</h3>

                <div class="features-grid">
                    <div class="feature-card">
                        <div class="feature-icon">
                            <svg width="48" height="48" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h4 class="feature-title">
                            {{ t('aboutUs.professionalTeamTitle') }}
                        </h4>
                        <p class="feature-description">
                            {{ t('aboutUs.professionalTeamDesc') }}
                        </p>
                    </div>

                    <div class="feature-card">
                        <div class="feature-icon">
                            <svg width="48" height="48" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                        <h4 class="feature-title">
                            {{ t('aboutUs.innovativeTechTitle') }}
                        </h4>
                        <p class="feature-description">
                            {{ t('aboutUs.innovativeTechDesc') }}
                        </p>
                    </div>

                    <div class="feature-card">
                        <div class="feature-icon">
                            <svg width="48" height="48" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                                <path fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                        <h4 class="feature-title">
                            {{ t('aboutUs.userCentricTitle') }}
                        </h4>
                        <p class="feature-description">
                            {{ t('aboutUs.userCentricDesc') }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- CTA Section -->
            <div class="stats-section">
                <h3 class="section-title">{{ t('aboutUs.ctaTitle') }}</h3>
                <div class="cta-button">
                    <NuxtLink to="/text-to-image" class="cta-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36" fill="none"
                            aria-hidden="true">
                            <path
                                d="M15.9216 26.6939L17.238 23.6786C18.4096 20.9954 20.5184 18.8594 23.1488 17.6918L26.7723 16.0833C27.9243 15.572 27.9243 13.896 26.7723 13.3846L23.2619 11.8264C20.5638 10.6288 18.4173 8.4137 17.2657 5.6389L15.9323 2.42558C15.4374 1.23314 13.7898 1.23314 13.295 2.42558L11.9614 5.63887C10.8099 8.4137 8.66329 10.6288 5.96527 11.8264L2.45487 13.3846C1.3028 13.896 1.3028 15.572 2.45487 16.0833L6.07845 17.6918C8.70883 18.8594 10.8176 20.9954 11.9891 23.6786L13.3056 26.6939C13.8116 27.8528 15.4155 27.8528 15.9216 26.6939ZM29.1021 34.0353L29.4723 33.1868C30.1323 31.6739 31.3211 30.4692 32.8043 29.8103L33.9449 29.3034C34.5618 29.0294 34.5618 28.1328 33.9449 27.8588L32.8682 27.3803C31.3467 26.7044 30.1367 25.4552 29.4879 23.8908L29.1078 22.9739C28.8428 22.3349 27.9593 22.3349 27.6942 22.9739L27.3141 23.8908C26.6655 25.4552 25.4555 26.7044 23.934 27.3803L22.8572 27.8588C22.2404 28.1328 22.2404 29.0294 22.8572 29.3034L23.9977 29.8103C25.4811 30.4692 26.6697 31.6739 27.3297 33.1868L27.7001 34.0353C27.971 34.6565 28.8311 34.6565 29.1021 34.0353Z"
                                fill="currentColor" />
                        </svg>
                        {{ t('aboutUs.ctaButton') }}
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { definePageMeta, useHead, useRequestURL } from '#imports'
import { useI18n } from '~/composables/useI18n'
import { useMultilingualSeo } from '~/composables/useMultilingualSeo'
import { computed } from 'vue'

definePageMeta({
    layout: 'website',
})

const { t } = useI18n()

useMultilingualSeo({ pageType: 'aboutUs' })

// BreadcrumbList + Organization 结构化数据
const requestUrlHref = useRequestURL().href

useHead({
    script: [
        // BreadcrumbList Schema
        {
            type: 'application/ld+json',
            innerHTML: computed(() =>
                JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                        {
                            '@type': 'ListItem',
                            position: 1,
                            name: '微鲤AI',
                            item: 'https://www.weryai.com.cn',
                        },
                        {
                            '@type': 'ListItem',
                            position: 2,
                            name: t('aboutUs.pageTitle'),
                            item: requestUrlHref,
                        },
                    ],
                })
            ),
        },
        // Organization Schema
        {
            type: 'application/ld+json',
            innerHTML: computed(() =>
                JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'Organization',
                    name: '微鲤AI',
                    url: 'https://www.weryai.com.cn',
                    logo: 'https://www.weryai.com.cn/weryai_512.png',
                    description: t('seo.aboutUs.description'),
                    foundingDate: '2024',
                    contactPoint: {
                        '@type': 'ContactPoint',
                        email: 'service@weryai.com.cn',
                        contactType: 'customer service',
                    },
                    knowsAbout: [
                        'AI Video Generation',
                        'AI Image Generation',
                        'Digital Human Technology',
                        'Text to Video',
                        'Text to Image',
                    ],
                })
            ),
        },
    ],
})
</script>

<style lang="less" scoped>
.about-page {
    min-height: 100vh;
    padding: 4rem 0;
    background: var(--global-bg-color);
    color: white;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 600px;
        background: url('https://static.weryai.com/growth/image/1b92835ec43c8642748fba2b9fe58c0d.webp') no-repeat top center;
        background-size: contain;
        opacity: 0.3;
        pointer-events: none;
        z-index: 0;
    }
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    position: relative;
    z-index: 1;
}

/* 主标题区域 */
.hero-section {
    text-align: center;
    margin-bottom: 5rem;
    padding-top: 2rem;
}

.title-decoration {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    margin-bottom: 1.5rem;
}

.decoration-icon {
    width: 60px;
    height: 60px;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.8;
        transform: scale(1.1);
    }
}

.main-title {
    font-size: 3.5rem;
    font-weight: 700;
    margin: 0;
    color: #f5f2f0;
    letter-spacing: -0.02em;
}

.subtitle {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--weryai-text-active);
    margin-bottom: 1.5rem;
    letter-spacing: 0.02em;
}

.description {
    font-size: 1.125rem;
    line-height: 1.8;
    color: #adadad;
    max-width: 800px;
    margin: 0 auto;
}

/* 通用区域样式 */
.platform-section,
.why-choose-section,
.stats-section {
    margin-bottom: 5rem;
}

.section-title {
    font-size: 2.25rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1.5rem;
    color: #f5f2f0;
    letter-spacing: -0.01em;
}

.section-description {
    font-size: 1.125rem;
    line-height: 1.8;
    color: #adadad;
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
}

/* 功能卡片网格 */
.features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
}

.feature-card {
    background: rgba(34, 36, 45, 0.8);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 2.5rem;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg,
                rgba(255, 94, 183, 0.1),
                rgba(255, 64, 187, 0.05));
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
    }

    &:hover {
        background: rgba(34, 36, 45, 1);
        transform: translateY(-8px);
        border-color: rgba(255, 94, 183, 0.3);
        box-shadow: 0 12px 40px rgba(255, 94, 183, 0.15);

        &::before {
            opacity: 1;
        }
    }
}

.feature-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg,
            var(--weryai-text-active),
            var(--active-btn));
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    color: white;
    position: relative;
    z-index: 1;
    box-shadow: 0 8px 20px rgba(255, 94, 183, 0.3);
}

.feature-title {
    font-size: 1.375rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #f5f2f0;
    position: relative;
    z-index: 1;
}

.feature-description {
    font-size: 1rem;
    line-height: 1.7;
    color: #adadad;
    position: relative;
    z-index: 1;
}

/* 统计数据区域 */
.stats-section {
    text-align: center;
    background: rgba(34, 36, 45, 0.6);
    backdrop-filter: blur(10px);
    border-radius: 24px;
    padding: 4rem 2rem;
    border: 1px solid rgba(255, 255, 255, 0.08);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle,
                rgba(255, 94, 183, 0.1) 0%,
                transparent 70%);
        animation: rotate 20s linear infinite;
        pointer-events: none;
    }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.cta-button {
    margin-top: 2.5rem;
    position: relative;
    z-index: 1;
}

.cta-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    background: var(--el-menu-active-color);
    color: white;
    text-decoration: none;
    padding: 1.25rem 3rem;
    border-radius: 16px;
    font-size: 1.25rem;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 8px 32px rgba(255, 94, 183, 0.4);
    position: relative;
    overflow: visible;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 16px;
        background: var(--el-menu-active-color);
        box-shadow: 0 12px 40px rgba(255, 94, 183, 0.6);
        opacity: 0;
        transform: scale(1);
        transition: all 0.6s ease;
        z-index: -1;
        pointer-events: none;
    }

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 16px 50px rgba(255, 94, 183, 0.5);
        text-decoration: none;
        color: white;

        &::before {
            opacity: 1;
            box-shadow: 0 20px 60px rgba(255, 94, 183, 0.4);
        }
    }

    svg {
        width: 24px;
        height: 24px;
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .about-page {
        padding: 2rem 0;

        &::before {
            height: 400px;
        }
    }

    .hero-section {
        margin-bottom: 3rem;
        padding-top: 1rem;
    }

    .decoration-icon {
        width: 40px;
        height: 40px;
    }

    .title-decoration {
        gap: 1rem;
    }

    .main-title {
        font-size: 2.5rem;
    }

    .subtitle {
        font-size: 1.25rem;
    }

    .description,
    .section-description {
        font-size: 1rem;
        line-height: 1.7;
    }

    .section-title {
        font-size: 1.75rem;
    }

    .platform-section,
    .why-choose-section,
    .stats-section {
        margin-bottom: 3rem;
    }

    .features-grid {
        grid-template-columns: 1fr;
        gap: 1.5rem;
        margin-top: 2rem;
    }

    .feature-card {
        padding: 2rem;
    }

    .feature-icon {
        width: 64px;
        height: 64px;
    }

    .feature-title {
        font-size: 1.25rem;
    }

    .stats-section {
        padding: 3rem 1.5rem;
    }

    .cta-link {
        padding: 1rem 2rem;
        font-size: 1.125rem;

        svg {
            width: 20px;
            height: 20px;
        }
    }
}

@media (max-width: 480px) {
    .main-title {
        font-size: 2rem;
    }

    .subtitle {
        font-size: 1.125rem;
    }

    .decoration-icon {
        width: 32px;
        height: 32px;
    }

    .container {
        padding: 0 0.75rem;
    }

    .feature-card {
        padding: 1.5rem;
    }

    .feature-icon {
        width: 56px;
        height: 56px;
    }

    .section-title {
        font-size: 1.5rem;
    }

    .stats-section {
        padding: 2.5rem 1rem;
    }

    .cta-link {
        padding: 0.875rem 1.5rem;
        font-size: 1rem;

        svg {
            width: 18px;
            height: 18px;
        }
    }
}
</style>
